import { render, staticRenderFns } from "./GameStory.vue?vue&type=template&id=4bb8533c&scoped=true&"
import script from "./GameStory.vue?vue&type=script&lang=js&"
export * from "./GameStory.vue?vue&type=script&lang=js&"
import style0 from "./GameStory.vue?vue&type=style&index=0&id=4bb8533c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8533c",
  null
  
)

export default component.exports